import React from 'react';
import { FaultMessageListProps } from './types/FaultMessageListProps';

export const FaultMessageList: React.FC<FaultMessageListProps> = ({ title, messages }) => {
  if (!messages || messages.length === 0) {
    return null;
  }

  return (
    <div className='flex flex-col text-left w-full'>
      <p className='font-semibold'>{title}</p>
      <ul className='flex flex-col gap-1 list-disc list-inside pl-1'>
        {messages.map((message, index) => (
          <li key={`${message}-${index}`}>{message}</li>
        ))}
      </ul>
    </div>
  );
};